
import React, { useState } from 'react'
import { Search, Button, Icon , Label} from 'semantic-ui-react'
import { useTranslation } from "react-i18next";
import "./LocationTab.css"

const LocationTab = () => {
    const { t } = useTranslation();
    
      
    
    return  <div className="locationtab d-flex flex-column">
        
      <Label className="border-none p-1" size="small" basic>
          GO ANYWHERE, ANYTIME
      </Label>
       <Button className="rounded-50" basic size='big' icon labelPosition='right'>
          I'm flexible
          <Icon name='right caret' className="bg-white"/>
      </Button>
    </div>
            
}
export default LocationTab